export { DealerLocatorTermsWrapper } from './dealer-locator-terms-wrapper';
